<template>
  <div class="next-step-container">
    <el-button
      v-if="showBackButton"
      class="back-button"
      type="primary"
      @click="handelBackSetp"
    >
      {{ backTitle }}
    </el-button>
    <el-button
      v-if="showNextButton"
      class="next-button"
      type="primary"
      @click="handelNextSetp"
    >
      {{ nextTitle }}
    </el-button>
  </div>
</template>

<script>

export default {
  components: {
  },
  props: {
    showNextButton: {
      default: true
    },
    showBackButton: {
      default: true
    },
    nextButtonTitle: {
      default: null
    },
    backButtonTitle: {
      default: null
    }
  },
  data () {
    return {
    }
  },
  computed: {
    nextTitle () {
      return this.nextButtonTitle || this.$t('hm.btn.next')
    },
    backTitle () {
      return this.backButtonTitle || this.$t('hm.btn.back')
    }
  },
  created () {

  },
  beforeDestroy () {

  },
  methods: {
    handelNextSetp ($event) {
      this.$emit('handelNextSetp', $event)
    },
    handelBackSetp ($event) {
      this.$emit('handelBackSetp', $event)
    }
  }
}
</script>

<style lang="scss" scoped>
.next-step-container {
  display: flex;
  padding: 10px 0;
  position: relative;
  height: 50px;

  .back-button {
    position: absolute;
    left: 0;
  }

  .next-button {
    position: absolute;
    right: 0;
  }

  ::v-deep .el-button {
    padding: 5px 20px;
    border-radius: 0;
    font-size: 12px;
    background-color: #0096cc;
    border-color: #0096cc;
  }
}
</style>
